export const applyCubismStyle = async (canvas, ctx, setMessage, language) => {
  // 입체주의: 기하학적 분해와 다각적 시점
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 색상 단순화 (기하학적 평면을 위해)
  const levels = 4; // 색상 레벨 수
  for (let i = 0; i < data.length; i += 4) {
    data[i] = Math.round(data[i] / (255 / levels)) * (255 / levels);
    data[i + 1] = Math.round(data[i + 1] / (255 / levels)) * (255 / levels);
    data[i + 2] = Math.round(data[i + 2] / (255 / levels)) * (255 / levels);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 기하학적 분할
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const cubistData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const cubistPixels = cubistData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 삼각형 및 다각형 영역으로 분할
  const blockSize = 20;
  for (let y = 0; y < canvas.height; y += blockSize) {
    for (let x = 0; x < canvas.width; x += blockSize) {
      // 블록 내의 평균 색상 계산
      let avgR = 0, avgG = 0, avgB = 0;
      let count = 0;
      
      for (let dy = 0; dy < blockSize && y + dy < canvas.height; dy++) {
        for (let dx = 0; dx < blockSize && x + dx < canvas.width; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          avgR += tempData[pos];
          avgG += tempData[pos + 1];
          avgB += tempData[pos + 2];
          count++;
        }
      }
      
      avgR /= count;
      avgG /= count;
      avgB /= count;
      
      // 블록을 기하학적 패턴으로 분할
      for (let dy = 0; dy < blockSize && y + dy < canvas.height; dy++) {
        for (let dx = 0; dx < blockSize && x + dx < canvas.width; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          
          // 대각선 분할 패턴
          const diagonal = (dx + dy) % (blockSize / 2);
          const colorVariation = diagonal < blockSize / 4 ? 1.1 : 0.9;
          
          cubistPixels[pos] = Math.min(255, avgR * colorVariation);
          cubistPixels[pos + 1] = Math.min(255, avgG * colorVariation);
          cubistPixels[pos + 2] = Math.min(255, avgB * colorVariation);
        }
      }
    }
  }
  
  ctx.putImageData(cubistData, 0, 0);
  
  // 3. 강한 윤곽선 추가 (입체주의의 특징)
  const edgeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const edgePixels = edgeData.data;
  
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 인접 픽셀과의 차이가 큰 경우 윤곽선 강화
      const current = (cubistPixels[pos] + cubistPixels[pos + 1] + cubistPixels[pos + 2]) / 3;
      const right = (cubistPixels[pos + 4] + cubistPixels[pos + 5] + cubistPixels[pos + 6]) / 3;
      const bottom = (cubistPixels[pos + canvas.width * 4] + 
                     cubistPixels[pos + canvas.width * 4 + 1] + 
                     cubistPixels[pos + canvas.width * 4 + 2]) / 3;
      
      if (Math.abs(current - right) > 50 || Math.abs(current - bottom) > 50) {
        edgePixels[pos] = 0;
        edgePixels[pos + 1] = 0;
        edgePixels[pos + 2] = 0;
      } else {
        edgePixels[pos] = cubistPixels[pos];
        edgePixels[pos + 1] = cubistPixels[pos + 1];
        edgePixels[pos + 2] = cubistPixels[pos + 2];
      }
    }
  }
  
  ctx.putImageData(edgeData, 0, 0);
};